import * as React from 'react';
import { TextField, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import { INayaxConfig } from '../../_types/location';

interface Props {
    classes: any;
    /** the item to display */
    item: INayaxConfig;
    onChange: (config: any) => void;
};

// LEARN
const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        }
//     home: { color: "primary" },
//     away: { color: theme.palette.grey[900] }
}));

const NayaxConfig: React.FC<Props> = (prop: Props) => {

    const classes = useStyles();

    return (
    <Grid container direction="row" alignItems="center">
        <Grid item>
            <FormControl className={classes.formControl}>
                <TextField label="Terminal ID" value={prop.item.TerminalId || ""} onChange={(e) => {let i = prop.item; i.TerminalId = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
        <Grid item>
            <FormControl className={classes.formControl}>
                <TextField label="UniQR" value={prop.item.UniQR || ""} onChange={(e) => {let i = prop.item; i.UniQR = e.target.value; prop.onChange(i)}}></TextField>
            </FormControl>
        </Grid>
    </Grid>
    );
}

export default NayaxConfig;
